"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Doughnut["default"];
  }
});
var _Doughnut = _interopRequireDefault(require("./Doughnut"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }